export const ERROR_MISSING_FRONTEND_API_URL =
  'The Clerk Frontend API URL is required to bypass bot protection. ' +
  'Make sure the clerkSetup function is called during your global setup before setupClerkTestingToken is called.';
